"use client";

import Slider from "react-slick";
import { MutableRefObject } from "react";
import { priceSymbol } from "@/utils/price-count";
import Link from "next/link";
import { TopProductsResponse } from "./best-selling-products";
import { Typography } from "../typography";
import { Tooltip } from "../tooltip/Tooltip";
import ProductCardImage from "../product-card/product-card-image";

interface Props {
  data: TopProductsResponse[];
  sliderRef: MutableRefObject<Slider | null>;
}

export const BestSellingProductsSlider = ({ data, sliderRef }: Props) => {
  const settings = {
    arrows: false,
    infinite: data.length > 3,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <Slider className="container mx-auto" ref={sliderRef} {...settings}>
      {data.map((product) => {
        const formattedName =
          product.name.charAt(0).toUpperCase() +
          product.name.slice(1).toLowerCase();

        return (
          <div className="flex flex-col relative w-full" key={product.id}>
            <div className="flex flex-col text-left justify-start items-center w-full">
              <div className="relative flex overflow-hidden justify-center items-center border aspect-square rounded-md p-5 md:w-[94%]  w-full ">
                {product?.images?.length > 0 && (
                  <Link href={`/products/${product.slug}`}>
                    <ProductCardImage product={product} />
                  </Link>
                )}
              </div>
              <Link href={`/products/${product.slug}`} className="w-full px-2">
                <Tooltip text={formattedName}>
                  <Typography
                    tag="h3"
                    className="my-1 line-clamp-3 w-[90%] max-h-fit text-[1.1em]"
                  >
                    {formattedName}
                  </Typography>
                </Tooltip>
                <Typography
                  tag="p"
                  className="text-gray-600 px-2 m-0 mt-2 max-h-fit line-clamp-2 break-words"
                >
                  {product.description}
                </Typography>
              </Link>
              <div className="flex gap-x-3 text-left justify-start w-full px-4">
                {product.flatDiscount > 0 && (
                  <Typography
                    tag="h6"
                    className="line-through text-gray-400 my-2"
                  >
                    {priceSymbol(product.price)}
                  </Typography>
                )}

                <Typography tag="h6" className="text-primary my-2">
                  {priceSymbol(product.price - product.flatDiscount)}
                </Typography>
              </div>
            </div>
          </div>
        );
      })}
    </Slider>
  );
};
